import jwt_decode from 'jwt-decode';
import getCookie from './getCookies';

const EXPIRY_MARGIN_SECONDS = 120;

interface JwtPayload {
  exp?: number;
}

export function getSsoAccessToken(): string {
  return getCookie('gov_access_token_sso') || '';
}

export function isSsoTokenValid(token?: string): boolean {
  const value = (token ?? getSsoAccessToken()).trim();
  if (!value) {
    return false;
  }

  try {
    const payload = jwt_decode<JwtPayload>(value);
    if (!payload.exp) {
      return true;
    }
    return payload.exp > Math.floor(Date.now() / 1000) + EXPIRY_MARGIN_SECONDS;
  } catch {
    return false;
  }
}

export function getSsoTokenValidationMessage(): string | null {
  const token = getSsoAccessToken().trim();
  if (!token) {
    return 'Sessão não encontrada. Faça login novamente para assinar.';
  }
  if (!isSsoTokenValid(token)) {
    return 'Sua sessão expirou. Faça login novamente para assinar.';
  }
  return null;
}

export function buildGovbrAuthHeaders(): Record<string, string> {
  const validationMessage = getSsoTokenValidationMessage();
  if (validationMessage) {
    throw new Error(validationMessage);
  }

  return {
    Authorization: `Bearer ${getSsoAccessToken().trim()}`,
  };
}

export function formatAssinaturaGovbrError(error: any): string {
  const responseData = error?.response?.data;
  const status = error?.response?.status;
  const traceId = responseData?.trace_id;
  const detail =
    responseData?.detail ||
    responseData?.message ||
    error?.message ||
    'Erro ao assinar documento com Gov.br.';

  let message = String(detail);
  const normalized = message.toLowerCase();

  if (status === 401) {
    if (
      normalized.includes('credenciais') ||
      normalized.includes('credentials were not provided')
    ) {
      message =
        'Sessão expirada ou inválida. Faça login novamente e tente assinar outra vez.';
    } else if (
      normalized.includes('token inválido') ||
      normalized.includes('invalid token')
    ) {
      message =
        'Sessão invalidada. Faça login novamente e tente assinar outra vez.';
    }
  }

  if (traceId && !message.includes(String(traceId))) {
    message = `${message} (trace_id: ${traceId})`;
  }

  return message;
}
